import { useAccountState } from 'contexts/account/account-context';
import { useMemo } from 'react';

export const useUserFeatures = () => {
  const {
    account: { company },
  } = useAccountState();

  /**
   * Features for the current user assigned through the User Roles within the context of the selected company
   */
  const accountFeatures = useMemo(() => company?.features, [company]);

  /**
   * DEPRECATED?
   * Determines whether or not the user can see the Calibration settings collapsible
   */
  const hasSiteSettingsCalibrationAccess = useMemo(
    () => (accountFeatures?.hasSiteSettingsRead || accountFeatures?.hasSiteSettingsWrite) && accountFeatures?.hasScenarioBuilder,
    [accountFeatures]
  );

  /**
   * Determines if the user can edit the Latitude Longitude
   */
  const canEditSiteSettingsLocation = useMemo(() => accountFeatures?.hasSiteSettingsWrite, [accountFeatures]);

  /**
   * Determines if a user can edit site settings
   */
  const canEditSiteSettings = useMemo(() => !accountFeatures?.hasSiteSettingsWrite, [accountFeatures]);

  return { hasSiteSettingsCalibrationAccess, canEditSiteSettingsLocation, canEditSiteSettings };
};
